import createModel from 'utils/model'
import _ from 'lodash'
import {
    getGroupList,
    getGroupGrouping,
    deleteGrouping,
    addGrouping,
    editGrouping,
    moveGrouping,
    getMoveCount,
} from 'crm/services/group-grouping'

function getInitTableParamsState() {
    return {
        keyword: undefined,
        category_id: undefined, // 当前分组的id
        limit: 10,
        offset: 0,
    }
}

function getInitTableState() {
    return {
        params: getInitTableParamsState(),
        total: 0,
        current: 1,
        tableData: [],
        customerGroupingList: [], // 客户分组列表
        name: undefined, // 新增/修改：分组的名字
        selectedRowKeys: [],
        moveCount: 0, // 移动的群数
    }
}

export default createModel({
    namespace: 'crm_groupGrouping',

    state: {
        ...getInitTableState(),
    },

    effects: {
        // eslint-disable-next-line no-unused-vars
        *getGroupList({payload}, {select, call, put}) {
            const {params, current} = yield select(({crm_groupGrouping}) => crm_groupGrouping)

            const newParams = _.cloneDeep(params)

            if (payload.page) {
                newParams.offset = newParams.limit * (payload.page - 1)
            }
            const res = yield call(getGroupList, newParams)

            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        tableData: res.data,
                        total: _.get(res, 'pagination.rows_found', 0),
                        current: _.get(payload, 'page', current),
                    },
                })
            }
        },

        // eslint-disable-next-line no-unused-vars
        *getGroupGrouping({callback}, {call, put}) {
            const res = yield call(getGroupGrouping)

            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        customerGroupingList: res.data,
                    },
                })
                callback && callback(res.data)
            }
        },

        *deleteGrouping({payload, callback}, {call}) {
            const res = yield call(deleteGrouping, payload)

            if (res && res.meta.code === 200) {
                callback && callback()
            }
        },

        *addGrouping({payload, callback}, {call}) {
            const res = yield call(addGrouping, payload)

            if (res && res.meta.code === 200) {
                callback && callback()
            }
        },

        *editGrouping({payload, callback}, {call}) {
            const res = yield call(editGrouping, payload)

            if (res && res.meta.code === 200) {
                callback && callback()
            }
        },

        *moveGrouping({payload, callback}, {call}) {
            const res = yield call(moveGrouping, payload)

            if (res && res.meta.code === 200) {
                callback && callback()
            }
        },

        *getMoveCount({payload, callback}, {call, put}) {
            const res = yield call(getMoveCount, payload)

            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        moveCount: res.data.count,
                    },
                })
                callback && callback()
            }
        },
    },

    reducers: {
        resetTableParams(state) {
            return {...state, params: getInitTableParamsState()}
        },
        resetTable(state) {
            return {...state, ...getInitTableState()}
        },
        mergeTableParams(state, action) {
            return {...state, params: {...state.params, ...action.payload}}
        },
    },
})
